import React, { useEffect, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Logo from "../assets/LogoBlue";
import { useNavigate } from "react-router-dom";
const theme = createTheme();

export default function SignInSide() {
  const [bg, setBg] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://api.pexels.com/v1/search?query=mosque&per_page=50", {
      headers: {
        // Authorization: process.env.PIXEL_API_KEY,
        Authorization:
          "j9pj0rBmAF8mMDwwoLlZ4tECrcOR3RtqXZqVmFkec4qxtIiXKN6tP6R6",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const photos = data.photos;
        const randomPhoto = photos[Math.floor(Math.random() * photos.length)];
        setBg(randomPhoto.src.original + "?h=2160&w=3840");
      });
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          width: "100%",
          height: "80vh",
          backgroundImage: `url(${bg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>

      <Grid container>
        <CssBaseline />
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div
            style={{
              marginTop: "-7rem",
              backgroundColor: "#fff",
              padding: "1.9rem",
              borderRadius: "50%",
            }}
          >
            <Logo width="13rem" />
          </div>
          <Typography
            variant="h3"
            component="div"
            style={{
              marginTop: "0.5rem",
              color: "#3ba59a",
            }}
          >
            World Azan Time
          </Typography>
          <Typography
            variant="blockquote"
            component="div"
            style={{
              fontWeight: "bold",
              fontSize: "1.6rem",
              padding: "1.5rem 0.5rem",
              width: " clamp(70%, 85vw, 40%)",
            }}
          >
            <blockquote cite="">
              A man asked Prophet Muhammad Peace Be Upon Him What kinds of deeds
              are best in the sight of God. He replied To pray on time.
              <br />{" "}
              <span style={{ fontWeight: "bold", color: "#3ba59a" }}>
                – Sahih Bukhari
              </span>
            </blockquote>
          </Typography>
          <Button
            style={{
              backgroundColor: "#FEC265",
              fontWeight: "bold",
              color: "black",
              width: "8rem",
            }}
            variant="contained"
            onClick={() => navigate("/al-Quran")}
          >
            Al Quran
          </Button>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
